"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sbd(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.07661 6.17189C7.23861 6.19964 6.83511 7.27439 7.06011 8.50214C7.25511 9.55439 9.69036 13.6291 9.58986 15.0271C9.51186 15.9046 7.51236 17.9634 7.30161 17.8261C7.07136 17.7624 7.90911 16.3636 7.59861 15.1981C7.23711 13.8391 5.09361 10.3261 5.09586 8.77514C5.09586 7.64039 6.93186 6.09839 7.07586 6.17189H7.07661ZM11.6584 4.56689C11.8639 4.60214 11.3509 5.97389 11.6374 7.53614C11.8849 8.88014 14.9921 14.0761 14.8631 15.8574C14.7626 16.9779 12.2141 19.6006 11.9441 19.4274C11.6516 19.3471 12.7196 17.5629 12.3236 16.0764C11.8639 14.3454 9.13011 9.86489 9.13236 7.88714C9.13236 6.43889 11.4739 4.47464 11.6584 4.56764V4.56689ZM16.3871 6.17189C16.5491 6.19964 16.1464 7.27439 16.3706 8.50214C16.5656 9.55439 19.0009 13.6291 18.9011 15.0271C18.8239 15.9046 16.8236 17.9634 16.6121 17.8261C16.3826 17.7624 17.2196 16.3636 16.9091 15.1981C16.5484 13.8391 14.4041 10.3261 14.4064 8.77514C14.4064 7.64039 16.2439 6.09839 16.3871 6.17189Z", fill: color }));
}
exports["default"] = sbd;
//# sourceMappingURL=sbd.js.map